import React from "react";

import Text from "src/components/text";

import { formatTimespent } from "src/services/reports.service";

import _ from "lodash";
import styles from "./userCard.module.scss";
import { User } from "src/types/users";
import { Analytics } from "src/types/reports";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface UserCardItem {
  user: User;
  analytics: Analytics;
}

export interface UserCardProps {
  item: UserCardItem;
}

export const UserCard: React.FC<UserCardProps> = ({ item }) => {
  const { user, analytics } = item;
  return (
    <div className={styles.card}>
      <img
        src={user.icon?.thumbnail || DefaultAssetIcon}
        className={`${styles.thumbnailIcon} ${styles.contactIcon}`}
        alt={`${user.firstName} ${user.lastName}`}
      />
      <div className={styles.content}>
        <Text
          lines={1}
          className={styles.title}
          text={`${user.firstName} ${user.lastName}`}
        />
        <div className={styles.metrics}>
          <span>{analytics.views || 0} Views</span>
          <span>
            {formatTimespent(_.get(analytics, "avgTimeSpent", 0))} Avg Time
          </span>
          <span>{analytics.shares || 0} Shares</span>
        </div>
        <div className={styles.meta}>
          {user.lastActivityDate &&
            `Last Active on: ${new Date(user.lastActivityDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}`}
        </div>
      </div>
    </div>
  );
};
